export function HamburgerIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>H a m b u r g e r</title>
      <path d="M0 8.33H16V7.33H0V8.33ZM0 4.33H16V3.33H0V4.33ZM0 12.33H16V11.33H0V12.33Z" fill="currentColor" />
    </svg>
  );
}
